import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import ErrorNotifier from '../scripts/services/error-notifier';

import { findUserByName } from './usersActions';
import { fetchSuggestionsError, fetchSuggestionsSuccess, setStatus } from './usersSlice';
import { FindUserByNameResponse } from './usersTypes';
import { findUserByNameRequest } from './usersApi';
import { parseUsers } from './usersUtils';

export function* findUserByNameSaga(action: PayloadAction<string>) {
  yield put(setStatus('loading'));

  try {
    const { suggestions }: FindUserByNameResponse = yield call(
      findUserByNameRequest,
      action.payload
    );

    const parsedSuggestions = parseUsers(suggestions);

    yield put(fetchSuggestionsSuccess(parsedSuggestions));
  } catch (error) {
    yield put(fetchSuggestionsError());
    ErrorNotifier.notifyError(`Failed to find user from autocompletion suggestions`, {
      username: action.payload
    });
  }
}

export function* usersSagas() {
  yield all([takeLatest(findUserByName, findUserByNameSaga)]);
}
